import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { INotification } from 'models/notifications/notification';
import { NotificationType } from 'models/enums/notificationtype';
import { INodeData } from 'models/common';
import * as moment from 'moment';
import { browserHistory } from 'react-router';
import { IShopCard } from 'models/shop/shopcard';
import { imgSrcAttributes, setProductPictureUrl } from 'helpers/common';
import { getShopOrder } from 'redux/modules/shop/shopordercard';
import { IShopOrderCardData } from 'models/orders/ordercard';
import { IStore } from 'redux/IStore';
import { Dispatch } from 'redux';
const { connect } = require('react-redux');

interface IProps extends IItemCardProps {
	item: INotification;
	shopOrderCard: IShopOrderCardData;
	userId: string;

	/* func props */
	t?: (key: string, options?: any) => string;
	getShopOrder?: (id: string, getCustomerData?: boolean) => Promise<void>;
}

export interface INotificationPlaceholder {
	placeholder: string;
	value: string;
	id: string;
	type: string;
}

@connect(
	(state: IStore) => ({
		shopOrderCard: state.shopOrderCard,
		userId: state.userPreferences.id,
	}),
	(dispatch: Dispatch<IStore>) => ({
		getShopOrder: (id: string, getCustomerData: boolean) => dispatch(getShopOrder(id, getCustomerData)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class NotificationItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
		this.goToShopOrder = this.goToShopOrder.bind(this);
		this.goToUserOrders = this.goToUserOrders.bind(this);
	}

	private goToCard(e: any, id: string, type: string, notificationId: string) {
		e.preventDefault();
		if (this.props.customFunction) {
			this.props.customFunction(notificationId);
		}
		if (this.props.goToCard) {
			this.props.goToCard(id, type);
		}
	}

	private goToShopOrder(e, notificationId: string) {
		e.preventDefault();
		if (this.props.customFunction) {
			this.props.customFunction(notificationId);
		}
		const shopOrderId = JSON.parse(this.props.item.to.entityId).id;
		this.props.getShopOrder(shopOrderId, true).then(() => {
			const shopId = this.props.shopOrderCard?.shopOrder?.shopId;
			if (shopId) {
				browserHistory.push(`/shop/${shopId}/edit/orders/order/${shopOrderId}`);
			}
		});
	}

	private goToUserOrders(e, notificationId: string) {
		e.preventDefault();
		if (this.props.customFunction) {
			this.props.customFunction(notificationId);
		}

		browserHistory.push(`/userorders`);
	}

	private goToUserAppointments(e, notificationId: string) {
		e.preventDefault();
		if (this.props.customFunction) {
			this.props.customFunction(notificationId);
		}

		browserHistory.push(`/profile/${this.props.userId}?tab=appointments`);
	}

	private formatText(text: string, notificationPlaceholders: INotificationPlaceholder[], notificationId: string) {
		const result = [];
		const getRegExp = () => {
			const regexp = [];
			notificationPlaceholders.forEach((item) => regexp.push(`\\[\\[${item.placeholder}\\]\\]`));
			return new RegExp(regexp.join('|'));
		};

		text.split(getRegExp()).forEach((item, i) => {
			if (notificationPlaceholders[i]) {
				const element = (
					<a
						key={i}
						href="#"
						onClick={(e) => {
							this.goToCard(e, notificationPlaceholders[i].id, notificationPlaceholders[i].type, notificationId);
						}}
					>
						{notificationPlaceholders[i].value}
					</a>
				);
				result.push(item, element);
			} else {
				result.push(item);
			}
		});

		return result;
	}

	public render() {
		const { t, customProps } = this.props;
		const { notificationType, from, to, viewed, addedDate, id } = this.props.item;

		const shop: IShopCard = customProps;

		let picture = null;

		const fromEntityIdObj: INodeData = JSON.parse(from.entityId);
		const toEntityIdObj: INodeData = JSON.parse(to.entityId);

		let content: any[] = null;

		switch (notificationType) {
			case NotificationType.OrderPending:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultUser.svg');
				content = this.formatText(
					t('Notification_Text_ItemIsSold_Part1'),
					[{ placeholder: 'name', value: from.name, id: fromEntityIdObj.id, type: fromEntityIdObj.type }],
					id,
				);
				content.push(
					<a
						key={`notif_card_${addedDate}`}
						href="#"
						onClick={(e) => {
							this.goToShopOrder(e, id);
						}}
					>
						{t('Notification_Text_ItemIsSold_Part2')}
					</a>,
				);
				break;

			case NotificationType.OrderProcessing:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultUser.svg');
				content = this.formatText(
					t('Notification_Text_ItemIsSold_Part1'),
					[{ placeholder: 'name', value: from.name, id: fromEntityIdObj.id, type: fromEntityIdObj.type }],
					id,
				);
				content.push(
					<a
						key={`notif_card_${addedDate}`}
						href="#"
						onClick={(e) => {
							this.goToShopOrder(e, id);
						}}
					>
						{t('Notification_Text_ItemIsSold_Part2')}
					</a>,
				);
				break;

			case NotificationType.AddWishlistProduct:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultUser.svg');
				content = this.formatText(
					t('Notification_Text_AddProductToWishlist'),
					[
						{ placeholder: 'name', value: from.name, id: fromEntityIdObj.id, type: fromEntityIdObj.type },
						{ placeholder: 'product', value: to.name, id: toEntityIdObj.id, type: toEntityIdObj.type },
					],
					id,
				);
				break;

			case NotificationType.FollowShop:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultUser.svg');
				content = this.formatText(
					t('Notification_Text_FollowShop'),
					[
						{ placeholder: 'name', value: from.name, id: fromEntityIdObj.id, type: fromEntityIdObj.type },
						{ placeholder: 'shop', value: to.name, id: toEntityIdObj.id, type: toEntityIdObj.type },
					],
					id,
				);
				break;

			case NotificationType.AddShopComment:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultUser.svg');
				content = this.formatText(
					t('Notification_Text_AddReview_Part1'),
					[{ placeholder: 'name', value: from.name, id: fromEntityIdObj.id, type: fromEntityIdObj.type }],
					id,
				);
				content.push(
					<a
						key={`notif_card_${addedDate}`}
						href="#"
						onClick={(e) => {
							this.goToCard(e, shop.id, c.NODE_TYPE_SHOP, id);
						}}
					>
						{t('Notification_Text_AddReview_Part2')}
					</a>,
				);
				break;

			case NotificationType.WishlistOnSale:
				picture = setProductPictureUrl(to.picture, false).src;
				content = this.formatText(
					t('Notification_Text_WishlistOnSale'),
					[{ placeholder: 'product', value: to.name, id: toEntityIdObj.id, type: toEntityIdObj.type }],
					id,
				);
				break;

			case NotificationType.OrderShipped:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultShop.svg');
				content = this.formatText(
					t('Notification_Text_OrderShipped_Part1'),
					[{ placeholder: 'shop', value: from.name, id: fromEntityIdObj.id, type: fromEntityIdObj.type }],
					id,
				);
				content.push(
					<a
						key={`notif_card_${addedDate}`}
						href="#"
						onClick={(e) => {
							this.goToUserOrders(e, id);
						}}
					>
						{t('Notification_Text_OrderShipped_Part2')}
					</a>,
				);
				break;

			case NotificationType.FollowingBirthday:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultUser.svg');
				content = this.formatText(
					t('Notification_Text_FollowingBirthday'),
					[{ placeholder: 'name', value: from.name, id: fromEntityIdObj.id, type: fromEntityIdObj.type }],
					id,
				);
				break;

			case NotificationType.AppointmentReminder:
				picture =
					from.picture && from.picture.length > 0 ? from.picture : require('containers/Html/images/defaultUser.svg');
				content = this.formatText(
					t('Email_Header_OrderReminder'),
					[{ placeholder: 'name', value: '', id: fromEntityIdObj.id, type: fromEntityIdObj.type }],
					id,
				);
				content.push(
					<React.Fragment key={`notif_card_${addedDate}`}>
						<br></br>
						<a
							href="#"
							onClick={(e) => {
								this.goToUserAppointments(e, id);
							}}
							style={{ textDecoration: 'underline' }}
						>
							{t('Notification_Text_SeeYourAppointments')}
						</a>
					</React.Fragment>,
				);
				break;

			default:
				break;
		}

		return (
			<div className={`notificationItemCard ${viewed ? '' : 'unseen'}`}>
				<div className="notificationImage">
					<img {...imgSrcAttributes(picture)} style={{ width: '40px', height: '40px' }} />
				</div>
				<div className="notificationText">
					<p className="name p14">{from.name}</p>
					<p className="event p14">{content}</p>
					<p className={`time p14 ${viewed ? 'grayGigo' : 'black'}`}>{moment.utc(addedDate).fromNow()}</p>
				</div>
			</div>
		);
	}
}

export { NotificationItemCard };
